@if (data) {
  @switch (data.Type) {
    @case (1) {
      <app-location></app-location>
    }
    @case (2) {
      <app-poi></app-poi>
    }
    @case (3) {
      <app-static-page></app-static-page>
    }
    @case (4) {
      <app-property-type></app-property-type>
    }
    @case (5) {
      <app-location [showSearch]="false"></app-location>
    }
    @case (6) {
      <app-property></app-property>
    }
  }
}
